import { render, staticRenderFns } from "./ConfigViewerSuspendedList.vue?vue&type=template&id=3a124587"
import script from "./ConfigViewerSuspendedList.vue?vue&type=script&lang=js"
export * from "./ConfigViewerSuspendedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports